import React, { useRef, useState } from 'react';
import { Upload, X, Loader2 } from 'lucide-react';
import { getApiUrl } from '../../lib/api';
import { toast } from 'sonner';

const ACCEPT = '.jpg,.jpeg,.png';
const MAX_SIZE = 20 * 1024 * 1024;

// photos: array of { id, url }  (url is absolute)
export const PhotoUploader = ({ label, photos, onChange, testId }) => {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleSelect = async (e) => {
    const selected = Array.from(e.target.files || []);
    e.target.value = '';
    if (!selected.length) return;
    setUploading(true);
    const uploaded = [];
    for (const f of selected) {
      if (f.size > MAX_SIZE) {
        toast.error(`${f.name} dépasse la limite de 20 Mo.`);
        continue;
      }
      try {
        const fd = new FormData();
        fd.append('file', f);
        const res = await fetch(`${getApiUrl()}/api/uploads`, { method: 'POST', body: fd });
        if (res.ok) {
          const d = await res.json();
          uploaded.push({ id: d.id, url: `${getApiUrl()}/api/media/${d.id}` });
        } else {
          const err = await res.json().catch(() => ({}));
          toast.error(err.detail || `Échec de l'envoi de ${f.name}.`);
        }
      } catch {
        toast.error(`Erreur réseau lors de l'envoi de ${f.name}.`);
      }
    }
    if (uploaded.length) onChange([...photos, ...uploaded]);
    setUploading(false);
  };

  const remove = (id) => onChange(photos.filter((p) => p.id !== id));

  return (
    <div className="space-y-2" data-testid={testId}>
      <label className="text-sm font-semibold text-slate-700">{label}</label>
      <div className="flex flex-wrap gap-3">
        {photos.map((p) => (
          <div key={p.id} className="relative w-24 h-24 rounded-lg overflow-hidden border border-slate-200 group">
            <img src={p.url} alt="" className="w-full h-full object-cover" />
            <button
              type="button"
              onClick={() => remove(p.id)}
              data-testid={`${testId}-remove-${p.id}`}
              className="absolute top-1 right-1 bg-black/60 hover:bg-red-600 text-white rounded-full p-1 transition-colors"
              aria-label="Retirer la photo"
            >
              <X className="h-3.5 w-3.5" />
            </button>
          </div>
        ))}
        <button
          type="button"
          onClick={() => inputRef.current?.click()}
          disabled={uploading}
          data-testid={`${testId}-trigger`}
          className="w-24 h-24 flex flex-col items-center justify-center gap-1 border-2 border-dashed border-slate-300 hover:border-emerald-500 rounded-lg text-slate-500 hover:text-emerald-600 transition-colors"
        >
          {uploading ? <Loader2 className="h-5 w-5 animate-spin" /> : <Upload className="h-5 w-5" />}
          <span className="text-[11px]">{uploading ? 'Envoi…' : 'Ajouter'}</span>
        </button>
      </div>
      <input
        ref={inputRef}
        type="file"
        multiple
        accept={ACCEPT}
        onChange={handleSelect}
        className="hidden"
        data-testid={`${testId}-input`}
      />
    </div>
  );
};

export default PhotoUploader;
